import { z } from 'zod';
import { isPermission } from '../permissions';
import { permissionEffectSchema } from './enums';
import { optionalString, requiredString } from './common';

/** A key from `shared/permissions.ts`; anything else is a 400, not a silent drop. */
const permissionKeySchema = z.string().refine(isPermission, { message: 'Unknown permission' });

export const roleInputSchema = z.object({
  name: requiredString('Name').max(60, 'Name must be at most 60 characters'),
  description: optionalString(),
  /** Closed over `requires` by the server before it is stored. */
  permissions: z.array(permissionKeySchema).max(1000),
});
export type RoleInput = z.infer<typeof roleInputSchema>;

export const cloneRoleSchema = z.object({
  name: requiredString('Name').max(60, 'Name must be at most 60 characters'),
});
export type CloneRoleInput = z.infer<typeof cloneRoleSchema>;

/** `PUT /users/:id/permissions` — the complete override list, replacing the old one. */
export const userOverridesSchema = z.object({
  overrides: z
    .array(z.object({ permission: permissionKeySchema, effect: permissionEffectSchema }))
    .max(1000)
    .refine((list) => new Set(list.map((override) => override.permission)).size === list.length, {
      message: 'A permission appears twice',
    }),
});
export type UserOverridesInput = z.infer<typeof userOverridesSchema>;
